"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Domain = void 0;
var lodash_1 = require("lodash");
var utils_1 = require("../utils");
exports.Domain = {
  /** Create a `Domain` object with given values. */
  create: function (values) {
    var isNumeric = (0, utils_1.isNumericArray)(values);
    return {
      values: values,
      isNumeric: isNumeric,
      sortDirection: isNumeric ? (0, utils_1.sortDirection)(values) : 'none',
      index: createIndex(values)
    };
  },
  /** For numeric domain: convert index to value, i.e.
   * return `index`-th value of the domain if `index` is an integer within [0, domain.values.length);
   * interpolate/extrapolate if `index` is a non-integer number or out of range.
   * For non-numeric domain: always return `undefined`. */
  interpolateValue: function (domain, index) {
    if (domain.isNumeric) {
      var values = domain.values;
      var previousIndex = (0, lodash_1.clamp)(Math.floor(index), 0, values.length - 2);
      var nextIndex = previousIndex + 1;
      var previousValue = values[previousIndex];
      var nextValue = values[nextIndex];
      return (index - previousIndex) * (nextValue - previousValue) + previousValue;
    } else {
      return undefined;
    }
  },
  /** Convert domain value to index, using interpolation. Return `undefined` for domains that are not numeric or not strictly sorted. */
  interpolateIndex: function (domain, value) {
    if (!domain.isNumeric) {
      console.warn('Cannot interpolate index because the domain is not numeric');
      return undefined;
    }
    if (typeof value !== 'number') {
      console.warn('Cannot interpolate index because the value is not numeric');
      return undefined;
    }
    var _a = domain,
      sortDirection = _a.sortDirection,
      values = _a.values;
    if (sortDirection === 'none') {
      console.warn('Cannot interpolate index because the domain is not sorted');
      return undefined;
    }
    var nextIndex = sortDirection === 'asc' ? (0, lodash_1.sortedIndex)(values, value) : (0, lodash_1.sortedIndexBy)(values, value, function (v) {
      return -v;
    });
    nextIndex = (0, lodash_1.clamp)(nextIndex, 1, values.length - 1);
    var previousIndex = nextIndex - 1;
    var previousValue = values[previousIndex];
    var nextValue = values[nextIndex];
    return (value - previousValue) / (nextValue - previousValue) + previousIndex;
  }
};
/** Create a mapping of values to their index in the array */
function createIndex(values) {
  var map = new Map();
  var n = values.length;
  for (var i = 0; i < n; i++) {
    map.set(values[i], i);
  }
  return map;
}